import { Controller } from "stimulus"

export default class extends Controller {
    redirect() {
        window.location.href = this.element.value;
    }
}